module.exports = __webpack_public_path__ + "static/media/Teacher.bc8c1d78.svg";